import React from 'react';
import PropTypes from 'prop-types';

import './fetchError.scss';

const FetchError = ({ refresh }) => (
    <div className="cmn-fetchError">
        <p className="cmn-fetchError__text">
            There&apos;s a technical issue that means we are currently unable to retrieve this
            data.
        </p>
        <p className="cmn-fetchError__text">
            We are working to resolve this and expect service to return to normal shortly.
        </p>
        <p className="cmn-fetchError__text">
            Your page should refresh in 20 seconds. If it does not refresh please click&nbsp;
            <button className="ui-link ui-link_secondary" onClick={refresh}>here</button>.
        </p>
        <p className="cmn-fetchError__text">
            Apologies for any inconvenience this has caused.
        </p>
    </div>
);

FetchError.propTypes = {
    refresh: PropTypes.func.isRequired
};

export default FetchError;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/FetchError/FetchError.jsx